// extracted by mini-css-extract-plugin
module.exports = {"loginFormContainer":"_971a281","loginFormHeading":"_7c0bc96","buttonWrapper":"_06aaaab","loginButton":"_134e1cb"};